import configureGateways from './configureGateways';
import configureGatewayObservers from './configureGatewayObservers';
import configureStore from './configureStore';
import { fetchAnswersSuccess } from 'app/modules/knowledge_base/demo';
import { initialState } from 'app/modules';
import loadConfiguration from './loadConfiguration';
import { autoShowWidget } from 'app/modules/ui/actions';

export default function(cdn, config, demoDataset) {
  return new Promise((resolve, reject) => {
    loadConfiguration(cdn, config.appId)
      .then(serverConfiguration => initializeApp(serverConfiguration, config, cdn, demoDataset))
      .then(data => resolve(data.store))
      .catch(reject);
  });
}

function initializeApp(serverConfiguration, config, cdn, demoDataset) {
  return new Promise((resolve, reject) => {
    let gateways = configureGateways({
      appId: config.appId,
      cdn,
      provider: serverConfiguration.provider,
    });

    let store = configureStore({ config, gateways }, initialState);
    configureGatewayObservers({ gateways, store, executeAction: store.dispatch });

    if (demoDataset) {
      store.dispatch(
        fetchAnswersSuccess({
          answers: demoDataset.snippets,
          suggestedAnswerIds: demoDataset.suggestedSelfServiceAnswerIds,
        })
      );
    }

    // kick off app bootstrap
    let configurationGateway = gateways.configurationGateway;
    configurationGateway.notifyObservers('handleFetchConfigSuccess', {
      config: _.assign({}, serverConfiguration, { demoSelfServiceEnabled: config.demoSelfServiceEnabled }),
      cohortId: configurationGateway.cohortId,
    });

    if (config.autoShowWidget) {
      store.dispatch(autoShowWidget());
    }

    resolve({ gateways, store });
  });
}
